import React from 'react';
import { Router } from 'react-router-dom';
import QuizzWidgetAppLayoutContainer from '../containers/QuizzWidgetAppLayoutContainer';
import history from '../history';

const QuizzWidgetAppRouter = () => (
    <Router history={history}>
        <QuizzWidgetAppLayoutContainer />
    </Router>
);

export default QuizzWidgetAppRouter;
